<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
    <vue-progress-bar></vue-progress-bar>
	<Footer></Footer>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { mapMutations, mapGetters } from 'vuex';
import Footer from '@/components/Footer'

export default {
	name: 'App',
	components:{
		Footer
	},
	beforeMount(){
		this.loadMe()
	},
	computed: {
		...mapGetters(['isAuthenticated','loggedUser'])
	},
	methods:{
		...mapMutations(['logout']),
		loadMe(){
			// console.log(this.isAuthenticated)
			if( this.isAuthenticated){
				this.$apollo.query({
					query: gql`query {
						me {
							id
							name
							email
						}
					}`,
					fetchPolicy: 'no-cache',
				})
				.then(() => {
					// console.log('main LoadMe then', data)
				})
				.catch(() => {
					this.$router.push('/logout')
				});
			}else{
				this.$router.push('/logout')
			}
		},
	}

}
</script>
